<template>
    <vx-tooltip text="Aantal besteld">
        <div class="text-3xl inline-block">{{this.quantity}}</div>
        <div class="text-xl inline-block">x</div>
    </vx-tooltip>
</template>

<script>
export default {
	props: {
		quantity: Number,
	},
}
</script>
